import React, { useState, useEffect } from 'react'
import IconButton from '../../buttons/icon-button'
import { withGridContext } from '../providers'
import { TextField } from '@app-soga/forms'
import { ContextType } from '../types/advanced-grid.types'
import usePrevProps from '../../../dist/advanced-grid/hooks/use-prev-props'

interface Props {
    delay?: number
}

/**
 * Component to render thegrid paginator control as a text field
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const PagesControl: React.FC<Props & ContextType> = ({
    currentPage,
    delay,
    events,
    loading,
    pages,
    resetCheckAll,
    pageSize
}) => {
    const { handleChangeCurrentPage, handleNextPage, handlePreviousPage } = events || {}
    const [current, setCurrent] = useState<number>(currentPage ? currentPage : 1)
    const prevProps = usePrevProps<{ pageSize?: number }>({ pageSize })
    let timer: ReturnType<typeof setTimeout>
    /**
     * Function to handle the pagination change
     * @param e
     */
    const handleChangePage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {
            target: { value }
        } = e
        if (handleChangeCurrentPage) {
            let newValue = parseInt(value, 10)
            if (!value || isNaN(newValue)) {
                newValue = 0
            } else if (pages && newValue >= pages) {
                newValue = pages
            }
            setCurrent(newValue)
            /**
             * This  technique it's used to allow the user enter zero values or delete completely
             * the text-field value without effect the table pagintation
             */
            timer = setTimeout(() => {
                handleChangeCurrentPage(newValue)
            }, delay)
        }
        if (resetCheckAll) {
            resetCheckAll()
        }
    }

    /**
     * Because the zero does not count we need to validate this and fix it
     */
    const handleNext = () => {
        if (handleNextPage && handleChangeCurrentPage) {
            if (currentPage === 0) {
                handleChangeCurrentPage(2)
                setCurrent(2)
            } else {
                const newValue = handleNextPage()
                setCurrent(newValue)
            }
        }
        if (resetCheckAll) {
            resetCheckAll()
        }
    }

    const handlePrev = () => {
        if (handlePreviousPage) {
            const newValue = handlePreviousPage()
            setCurrent(newValue)
        }
        if (resetCheckAll) {
            resetCheckAll()
        }
    }

    useEffect(() => {
        if (pageSize !== prevProps.pageSize && current > 1) {
            setCurrent(1)
        }
        return () => clearTimeout(timer)
    }, [pageSize, current])
    return (
        <div className="flex items-center">
            <IconButton
                className="mr-2"
                disabled={loading}
                icon="chevron-circle-left"
                size="2x"
                onClick={handlePrev}
            />
            <div className="w-14">
                <TextField
                    disabled={loading}
                    className="text-right"
                    groupClassName="mb-0"
                    onChange={handleChangePage}
                    value={current}
                />
            </div>
            <span className="mx-2">{`Of ${pages}`}</span>
            <IconButton
                disabled={loading}
                icon="chevron-circle-right"
                onClick={handleNext}
                size="2x"
            />
        </div>
    )
}

PagesControl.defaultProps = {
    delay: 1000
}

export default withGridContext(PagesControl)
